import { Component, effect, inject, input, model } from '@angular/core';

import { NgSelectComponent } from '@ng-select/ng-select';

import { CrudService } from '../../core/services/crud.service';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { removeEmptyValues } from '../../shared/helpers';

import { ModalComponent } from '../../shared/components/modal/modal.component';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-user-form',
  imports: [ReactiveFormsModule, NgSelectComponent, ModalComponent],
  providers: [DatePipe],
  templateUrl: './user-form.component.html',
  styles: ``,
})
export class UserFormComponent {
  private crudService = inject(CrudService);
  private datePipe = inject(DatePipe);

  showModal = model(false);
  existingUser = input(null);

  roles: Array<any> = [];

  confirmationMessage = '';
  errorMessage = '';

  userForm = new FormGroup({
    first_name: new FormControl('', Validators.required),
    last_name: new FormControl('', Validators.required),
    second_last_name: new FormControl(''),
    birth_date: new FormControl('', Validators.required),
    phone: new FormControl('', [
      Validators.required,
      Validators.pattern(/^\d{10}$/),
    ]),
    email: new FormControl('', [Validators.required, Validators.email]),
    username: new FormControl('', Validators.required),
    password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    role: new FormControl('', Validators.required),
  });

  buttonText = '';

  constructor() {
    effect(() => {
      if (this.showModal()) {
        this.initializeCombos();

        if (this.existingUser() !== null) {
          this.buttonText = 'Actualizar';

          this.userForm.patchValue({
            first_name: (this.existingUser() as any)['first_name'],
            last_name: (this.existingUser() as any)['last_name'],
            second_last_name: (this.existingUser() as any)['second_last_name'],
            birth_date: this.datePipe.transform(
              (this.existingUser() as any)['birth_date'],
              'yyyy-MM-dd'
            ),
            phone: (this.existingUser() as any)['phone'],
            email: (this.existingUser() as any)['email'],
            username: (this.existingUser() as any)['username'],
            password: (this.existingUser() as any)['password'],
            role: (this.existingUser() as any)['role'],
          });
        } else {
          this.buttonText = 'Crear';
          this.clearForm();
        }
      }
    });
  }

  submit() {
    const cleanUserForm = removeEmptyValues(this.userForm.value);
    this.confirmationMessage = '';
    this.errorMessage = '';

    this.userForm.controls.birth_date.setValue(
      new Date(this.userForm.controls.birth_date.value as string).toISOString()
    );

    if (this.existingUser() != null) {
      this.updateUser(this.userForm.value);
    } else {
      this.createUser(cleanUserForm);
    }
  }

  createUser(cleanUserForm: any) {
    this.crudService.createUser(cleanUserForm).subscribe({
      next: (response: any) => {
        if (response.status === 201) {
          this.confirmationMessage = 'Usuario creado';
          this.clearForm();
        }
      },
      error: (error: any) => {
        if (error.status === 409) {
          this.errorMessage = error.error.message;
        } else {
          this.errorMessage = 'Error inesperado. Intente nuevamente.';
        }
        this.clearForm();
      },
    });
  }

  updateUser(userForm: any) {
    this.crudService
      .updateUser((this.existingUser() as any)['id'], userForm)
      .subscribe({
        next: (response: any) => {
          if (response.ok) {
            this.close();
          }
        },
      });
  }

  cancel() {
    this.close();
  }

  close() {
    this.showModal.set(false);
  }

  initializeCombos() {
    this.crudService.getEnum('Role').subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.roles = Object.entries(response.body).map(([key, value]) => {
            return { id: key, name: value };
          });
        }
      },
    });
  }

  clearForm() {
    this.userForm.reset({
      first_name: '',
      last_name: '',
      second_last_name: '',
      birth_date: '',
      phone: '',
      email: '',
      username: '',
      password: '',
      role: '',
    });
  }
}
